import React, { PureComponent } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";
import { ButtonGroup, Button } from "aible";

const COLORS = ["#C03E5A", "rgba(242, 205, 137, 1)", "#54C06C", "rgba(189, 189, 189, 1)"];

export const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

import styles from "./style.module.css";

export default class AssumptionLegend extends PureComponent {
  renderLegend(props) {
    const { payload } = props;
    const { innerId, updateDrilldownValue } = this.props;

    return (
      <div className={styles.aLegend}>
        <ButtonGroup>
          {payload.map((entry, index) => (
            <Button
              key={index}
              active={innerId == entry[index].runId}
              onClick={() => updateDrilldownValue(entry[index].runId, entry[index].label)}
            >
              <span
                className={styles.aCircle}
                style={{ background: entry.color, display: this.checkIsOverall(entry[index]) ? "none" : undefined }}
              />
              {entry[index].label}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    );
  }

  checkIsOverall(dataPoint) {
    return dataPoint && dataPoint.value === "Overall";
  }

  getColor(dataPoint, index, hasOverall) {
    const { drilldownValue } = this.props;
    if (dataPoint.value === drilldownValue) {
      return "#F47C20";
    } else {
      if (hasOverall) {
        if (this.checkIsOverall(dataPoint)) {
          return "transparent";
        } else {
          return colorsTwo[Math.max(0, index - 1) % colorsTwo.length];
        }
      } else {
        return colorsTwo[i % colorsTwo.length];
      }
    }
  }

  render() {
    const { data, drilldownValue, onClick } = this.props;

    const hasOverall = data.find((elem) => this.checkIsOverall(elem));
    return (
      <ResponsiveContainer>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie innerRadius={0} outerRadius={0} fill="#8884d8" paddingAngle={0} dataKey="value">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={this.getColor(entry, index, hasOverall)} />
            ))}
          </Pie>
          <Legend
            layout={"horizontal"}
            align={"left"}
            iconType={"circle"}
            payload={data.map((d, i) => ({
              ...data,
              fill: d.color,
              color: d.color
            }))}
            content={this.renderLegend.bind(this)}
          />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
